import { SCREEN_ROUTE_ACCESS } from '@/config/routeAccessRegistry';
import { resolveParentRoutePath } from '@/config/routeAccessUtils';

const REGISTERED_SCREEN_PATHS = new Set(Object.keys(SCREEN_ROUTE_ACCESS));

export function isRegisteredScreenPath(pathname: string): boolean {
  return REGISTERED_SCREEN_PATHS.has(pathname.split('?')[0]);
}

/** Page access — exact match for registered screens; parent inheritance for dynamic URLs only. */
export function resolvePageScreenActionPath(
  pathname: string,
  visiblePaths: string[],
): string | undefined {
  const base = pathname.split('?')[0];
  if (visiblePaths.includes(base)) {
    return base;
  }
  if (REGISTERED_SCREEN_PATHS.has(base)) {
    return undefined;
  }
  return resolveParentRoutePath(base, visiblePaths);
}
